/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { DateHelper } from '@src/app/shared/dateHelper';
import { AbstractObject, uuid } from '@src/app/model/abstract-object';
import { Person } from '@src/app/model/person';
import { Role } from '@src/app/model/role';
import { Team } from '@src/app/model/team';
import { Unit } from '@src/app/model/unit';

export class PersonUnitRole extends AbstractObject {
  personId: uuid;
  person: Person;
  unitId: uuid;
  unit: Unit;

  lastLoginAt: number;
  logins: number;

  team?: Team;
  personFullName: string; // lives on people table
  personEmail: string; // lives on people table
  integrationId: string; // lives on people table
  unitName: string;
  roleName: string;

  roleId: uuid;
  ownerChangeId?: uuid;

  role: Role;
  startDate = '';
  endDate = '';
  isCurrent?: 1|null;

  constructor(o: Partial<PersonUnitRole> = {}) {
    super(o);
  }
  static isCurrent(o: PersonUnitRole) {
      if ((o === null) || o === undefined) {
          return false
      } else if (o.startDate && !DateHelper.beforeToday(o.startDate)) {
          return false;
      } else if ((o.endDate && DateHelper.beforeToday(o.endDate))) {
          return false;
      } else {
          return true;
      }
  }
}
